<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('buyVideo.userId')" prop="userId" >
        <a-input v-model="form.userId" :placeholder="$t('buyVideo.inputUserId')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('buyVideo.videoId')" prop="videoId" >
        <a-input v-model="form.videoId" :placeholder="$t('buyVideo.inputVideoId')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('buyVideo.gatherId')" prop="gatherId" >
        <a-input v-model="form.gatherId" :placeholder="$t('buyVideo.inputGatherId')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('buyVideo.typeLabel')" prop="type" >
      </a-form-model-item>
      <a-form-model-item :label="$t('buyVideo.price')" prop="price" >
        <a-input v-model="form.price" :placeholder="$t('buyVideo.inputPrice')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('buyVideo.remark')" prop="remark" >
        <a-input v-model="form.remark" :placeholder="$t('buyVideo.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBuyVideo, addBuyVideo, updateBuyVideo } from '@/api/user/buyVideo'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        videoId: null,

        gatherId: null,

        type: null,

        price: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        userId: [
          { required: true, message: this.$t('buyVideo.userIdRequired') }
        ],
        videoId: [
          { required: true, message: this.$t('buyVideo.videoIdRequired') }
        ],
        gatherId: [
          { required: true, message: this.$t('buyVideo.gatherIdRequired') }
        ],
        type: [
          { required: true, message: this.$t('buyVideo.typeRequired'), trigger: 'change' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        videoId: null,
        gatherId: null,
        type: null,
        price: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBuyVideo({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBuyVideo(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBuyVideo(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
